import { FILE_STATUS, STATUS } from '../../enums/common'
import {
  IUploadFormState,
  IUploadWithRetryFormState,
} from '../../interfaces/Upload'

export const uploadState: IUploadFormState = {
  file: [null],
  status: STATUS.idle,
  toggleValidateButton: false,
  fileAlerts: [],
  fileStatus: [FILE_STATUS.pending],
  docInfo: [],
  validationButtonError: null,
  docValue: '',
}

export const uploadWithRetryState: IUploadWithRetryFormState = {
  file: [null, null],
  status: STATUS.idle,
  toggleValidateButton: false,
  fileAlerts: [],
  fileStatus: [FILE_STATUS.pending],
  docInfo: [],
  validationButtonError: null,
  docValue: '',
  uploadCount: [],
  statusVerification: [],
  canRetry: [],
  docUserDetails: {},
  documentsUid: [],
}

export const step2InitialState = { ...uploadState, file: [] }
